import { useEffect, useState } from 'react'
import { TextField } from '@mui/material';

const RegexValidatedTextField = ({ label, errorMessage, regex, required = true, onValidChange, value, ...props }) => {
        const [error, setError] = useState('');
        const [helperText, setHelperText] = useState('');

        useEffect(() => {
            const input = value || '';

            const isValid = regex ? regex.test(input) : true;

            if (!isValid && (required || input !== '')) {
                setError(true);
                setHelperText(errorMessage);
            } else {
                setError(false);
                setHelperText('');
            }
        })

        const handleChange = (event) => {
            const input = event.target.value;

            if (onValidChange) {
                const isValid = regex ? regex.test(input) : true;
                onValidChange(input, isValid);
            }
        };

        return (
            <TextField
            label={label}
            value={value}
            onChange={handleChange}
            error={error}
            helperText={helperText}
            required={required}
            {...props}
            />
        );
};

export default RegexValidatedTextField;